// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../variables.css'","container":"style_container__1IjzV"};